/*
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-08-29 15:44:30
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-09-08 14:27:10
 */
var locale = {
    locale: 'phi',
    today: 'ngayon',
    now: 'ngayon',
    backToToday: 'Bumalik sa ngayon',
    ok: 'Oo naman',
    timeSelect: 'panahon ng pagpili',
    dateSelect: 'Pumili ng petsa',
    weekSelect: 'Pumili ng linggo',
    clear: 'para i-clear',
    month: 'buwan',
    year: 'taon',
    previousMonth: 'Noong nakaraang buwan (up button)',
    nextMonth: 'Sa susunod na buwan (down button para i-turn page)',
    monthSelect: 'Piliin ang Buwan',
    yearSelect: 'Pumili ng taon',
    decadeSelect: 'piliin ang edad',
    yearFormat: 'Taon YYYY',
    dayFormat: 'D-araw',
    dateFormat: 'M, D, YYYY',
    dateTimeFormat: 'YYYY taon M buwan D araw HH oras mm minuto ss segundo',
    previousYear: 'Nakaraang taon (Control key plus left arrow key)',
    nextYear: 'Sa susunod na taon (Control key plus right arrow key)',
    previousDecade: 'nakaraang henerasyon',
    nextDecade: 'susunod na henerasyon',
    previousCentury: 'noong nakaraang siglo',
    nextCentury: 'susunod na siglo'
};
export default locale;